import { notification } from 'antd';
import type { FormCompartilharValues, ICompartilhar } from '@/components/revisar/FormCompartilhar';
import type { ApiResponse } from '@/std/api/types';
import { getEmpresaIdpk } from '@/features/login/util';
import { buildUrl } from '@/std/api/buildUrl';
import { comTokenPost } from '@/std/api/comToken';
import { isResponseOk } from '@/std/api/util';
import { Endpoint } from '@/types/enum/endpoint';

export const enviarNotaFiscalPorWhatsapp = async (
    values: FormCompartilharValues,
    dadosCompartilhamento: ICompartilhar,
    onCloseCompartilhar: () => void,
): Promise<void> => {
    const params = {
        empresa_idpk: getEmpresaIdpk(),
        template_id: 'EMPRESA_PADRAO',
        tipo: 'W',
    };

    const url = new URL(dadosCompartilhamento.link);
    url.searchParams.set('registrarVisualizacao', 'true');

    const body = {
        fin_fone: values.telefone,
        tags: [
            {
                nome: 'mensagem',
                valor: values.mensagem,
            },
            {
                nome: 'url',
                valor: url.toString(),
            },
        ],
    };

    const urlApi = buildUrl(Endpoint.NotaFiscalCompartilhar, params, dadosCompartilhamento.idpk);

    try {
        const response: ApiResponse = await comTokenPost(urlApi, body);
        if (!isResponseOk(response)) {
            throw new Error();
        }

        if (response.data.status !== 'sucesso') {
            return;
        }

        notification.success({
            description: 'Atenção, a notificação pode demorar até 5 minutos para ser entregue.',
            title: 'WhatsApp enviado',
        });

        onCloseCompartilhar();
    } catch (e) {
        notification.error({
            description: e instanceof Error ? e.message : 'Erro desconhecido',
            title: 'Não foi possível enviar mensagem via WhatsApp',
        });

        onCloseCompartilhar();
    }
};
